<template>
  <section class="tc-prog" aria-labelledby="tu-construye-progress-title">
    <img class="tc-prog__image" :src="obraImage" alt="Trabajadores revisando los planos de una obra">

    <div class="tc-prog__content">
      <span class="tc-prog__tag">Tu obra</span>
      <h2 id="tu-construye-progress-title" class="tc-prog__title">Así es como medimos tu obra</h2>

      <ul class="tc-prog__items">
        <li v-for="stage in stages" :key="stage.title" class="tc-prog__item">
          <span class="tc-prog__value">{{ stage.value }}</span>
          <div class="tc-prog__text">
            <h3 class="tc-prog__item-title">{{ stage.title }}</h3>
            <p v-html="stage.description" />
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import obraImage from '../../../assets/tu-construye-figma/obra.jpg'

const stages = [
  { value: '30%', title: 'Cimentación', description: 'Nivelación, excavación, drenaje y estructura de base.' },
  { value: '30%', title: 'Estructura y Techado', description: 'Muros, losa, castillos y columnas.' },
  { value: '25%', title: 'Acabados', description: 'Pisos, aplanados, instalaciones eléctricas/hidráulicas, ventanas <br class="br-m">y puertas.' },
  { value: '15%', title: 'Terminación', description: 'Pintura, azulejos, muebles de baño <br class="br-m">y cocina.' }
]
</script>

<style scoped>
.tc-prog { display: flex; align-items: stretch; gap: var(--ds-space-5); }

.tc-prog__image {
  flex: 0 0 370px;
  width: 370px;
  min-width: 0;
  object-fit: cover;
  border-radius: 24px;
}

.tc-prog__content {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--ds-space-6);
  min-width: 0;
}

.tc-prog__tag {
  display: inline-flex;
  align-items: center;
  padding: var(--ds-space-3);
  border-radius: 9999px;
  background: var(--ds-tag-orange-fill);
  color: var(--ds-tag-orange-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.tc-prog__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}

.tc-prog__items { display: flex; flex-direction: column; gap: var(--ds-space-6); width: 100%; margin: 0; padding: 0; list-style: none; }
.tc-prog__item { display: flex; align-items: center; gap: var(--ds-space-4); }
.tc-prog__value {
  flex: 0 0 auto;
  color: #6D59EA;
  font-family: var(--ds-font-family-bebas);
  font-size: 40px;
  font-weight: 700;
  line-height: 44px;
  white-space: nowrap;
}
.tc-prog__text { display: flex; flex: 1 1 0; flex-direction: column; gap: var(--ds-space-2); min-width: 0; }
.tc-prog__item-title { margin: 0; color: var(--ds-text-body); font-size: 16px; font-weight: 600; line-height: 24px; }
.tc-prog__text p { margin: 0; color: var(--ds-text-body); font-size: 14px; line-height: 20px; }

@media (max-width: 1024px) {
  .tc-prog__image { flex-basis: 272px; width: 272px; }
}

/* Mobile: el contenido va primero y la foto de 462px de alto al final */
@media (max-width: 599px) {
  .tc-prog { flex-direction: column-reverse; gap: var(--ds-space-6); }
  .tc-prog__image { flex: none; width: 100%; height: 462px; }
  .tc-prog__content { flex: none; justify-content: flex-start; width: 100%; }
}
</style>
